// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__10fiR","log":"ModalInventoryLogs_log__3EP7v","date":"ModalInventoryLogs_date__34ksk","userName":"ModalInventoryLogs_userName__2fVxZ"};